import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BaseResponse,
  RegisteredUploadItem,
  UploadWidgetItemDetailsDto,
  UploadWidgetItemDto,
  UploadWidgetRegisterPayload,
} from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { uploadWidgetRecordReportUrl, uploadWidgetRecordsUrl, uploadWidgetRecordUrl } from './upload-widget-api.constant';

@Injectable({ providedIn: 'root' })
export class UploadWidgetApiService {
  private readonly http = inject(HttpClient);

  getRecords(): Observable<BaseResponse<UploadWidgetItemDto[]>> {
    return this.http.get<BaseResponse<UploadWidgetItemDto[]>>(uploadWidgetRecordsUrl());
  }

  getRecordDetails(uuid: string): Observable<BaseResponse<UploadWidgetItemDetailsDto>> {
    return this.http.get<BaseResponse<UploadWidgetItemDetailsDto>>(uploadWidgetRecordUrl(uuid));
  }

  registerUpload(payload: UploadWidgetRegisterPayload): Observable<BaseResponse<RegisteredUploadItem>> {
    return this.http.post<BaseResponse<RegisteredUploadItem>>(uploadWidgetRecordsUrl(), payload);
  }

  clearHistory(): Observable<BaseResponse<void>> {
    return this.http.delete<BaseResponse<void>>(uploadWidgetRecordsUrl());
  }

  removeRecord(uuid: string): Observable<BaseResponse<void>> {
    return this.http.delete<BaseResponse<void>>(uploadWidgetRecordUrl(uuid));
  }

  /** Returns the full response so the filename can be read from the `Content-Disposition` header. */
  downloadReport(uuid: string): Observable<HttpResponse<Blob>> {
    return this.http.get(uploadWidgetRecordReportUrl(uuid), { observe: 'response', responseType: 'blob' });
  }
}
